import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'

export class ProductMedia extends BaseComponent {
  mountComponent(): void {
    this.setReady()
  }

  updateFirstMediaByVariant(variant, jump = false): void {
    if (variant && variant.featured_media) {
      const media = $el(`[data-media-id="${variant.featured_media.id}"]`, this)

      const element = media ?? this

      element.scrollIntoView({
        behavior: jump ? 'auto' : 'smooth',
      })
    } else {
      this.scrollIntoView({
        behavior: jump ? 'auto' : 'smooth',
      })
    }
  }

  setReady(): void {
    this.setAttribute('ready', '')
  }
}
